import { useNavigate, useParams } from 'react-router-dom';

import { Button, ButtonSize, ButtonType } from '@xemplo/button';
import { DawnClipboardTick, IconGradient } from '@xemplo/icons';
import { useGetPayscheduleByIdQuery } from '@xemplo/pay-schedule-query';

import { getFieldsArray } from './pay-schedule-details-card.helpers';
import * as S from './pay-schedule-details-card.styles';

export function PayScheduleDetailsCard(props: { className?: string }) {
  const { payscheduleId } = useParams<{ payscheduleId: string }>();
  const { data } = useGetPayscheduleByIdQuery({ id: payscheduleId });

  if (!data?.result) {
    return null;
  }

  const fields = getFieldsArray(data.result);

  return (
    <S.CardContainer className={props.className}>
      <S.Header>
        <S.IconWrapper>
          <DawnClipboardTick fontSize={24} />
          <IconGradient />
        </S.IconWrapper>
        <S.Title>Pay Schedule Details</S.Title>
        <EditPayScheduleButton />
      </S.Header>

      <S.FieldsGrid>
        {fields.map((field) => (
          <S.Field key={field.id} data-field-id={field.id}>
            <S.Label>{field.label}</S.Label>
            <S.Value>{field.value}</S.Value>
          </S.Field>
        ))}
      </S.FieldsGrid>
    </S.CardContainer>
  );
}

/**
 * This is a temporary edit button. It redirects to the legacy edit screen which will eventually be replaced with a new edit form.
 */
function EditPayScheduleButton() {
  const navigate = useNavigate();
  const { payscheduleId } = useParams<{ payscheduleId: string }>();
  const { data } = useGetPayscheduleByIdQuery({ id: payscheduleId });

  const targetUrl = `/payschedule/${payscheduleId}/edit?companyid=${data?.result.companyId}&businessunitid=${data?.result.businessUnitId}`;

  return (
    <Button
      type={ButtonType.Secondary}
      ariaLabel="edit pay schedule"
      onClick={() => navigate(targetUrl)}
      size={ButtonSize.Small}
    >
      Edit
    </Button>
  );
}
